// @flow

import get from 'lodash/get';

import type { RenewableProduct } from '../types';

export const isTrial = (resource: RenewableProduct): boolean => {
  const dateCreated = resource.meta_data.started_at;
  const dateEnd = resource.meta_data.expires_at;
  const start = new Date(dateCreated);
  const end = new Date(dateEnd);

  const oneHour = 60 * 60 * 1000;
  const tenDays = 10 * 24 * oneHour;
  // this is a trial if time between creation and end is 10 days.
  // given daylight saving uncertainity, we add a full hour.
  return end.getTime() - start.getTime() <= tenDays + oneHour;
};

export function isRestorable(renewableProduct: RenewableProduct): boolean {
  const restorable =
    renewableProduct.meta_data &&
    renewableProduct.meta_data.restorable !== undefined
      ? renewableProduct.meta_data.restorable
      : renewableProduct.status === 'deleted';
  return restorable;
}

export function isRenewable(info: mixed): boolean {
  const durations = get(info, 'durations') || [];
  return !!(
    !get(info, 'prohibited') &&
    get(info, 'in_renew_period') &&
    // $FlowFixMe T54746
    ('renewable' in (info || {}) ? info.renewable : true) &&
    durations.length > 0
  );
}
